import { render, staticRenderFns } from "./WrinkleLocationsTemplate.vue?vue&type=template&id=17ca626e"
import script from "./WrinkleLocationsTemplate.vue?vue&type=script&lang=js"
export * from "./WrinkleLocationsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports